<template>
  <div class="tab-content">
    <div class="title-wrap">
      <div class="left">
        <span class="title">{{ cnt.title }}</span>
        <span class="btnfr">
          <router-link class="campaign-price-entry" to="/11huodong" aria-label="双十一钜惠，查看充值活动">
            <img src="@/assets/images/activity/charge.gif" class="btnimg" alt="双十一钜惠" />
          </router-link>
          <!-- <img
            src="@/assets/images/activity/charge11.gif"
            class="btnimg"
            @click="gotoPay()"
          /> -->
          <!-- <el-button class="btnf" @click="gotoPay()">双11限时钜惠</el-button> -->
        </span>
      </div>
      <div class="right">
          <div v-show="cnt.price>0"><span class="btnfr11">
          {{ cnt.price }}元{{ cnt.priceIsStart ? "起" : "/张" }}
        </span></div>
          <div v-if="cnt.status" class="teach-btn" @click="constDetail">
            使用教程<i class="el-icon-question el-icon--right"></i>
          </div>
          <div class="fr1" v-else>
            <el-button type="danger" icon="el-icon-close" circle></el-button
            >维护
          </div>
        </div>
    </div>
    <div class="warning" v-if="cnt.tip != '' && cnt.tip != null">
      <p v-html="cnt.tip"></p>
    </div>
    <el-input
      type="textarea"
      class="textarea"
      v-model="cnt.label"
      @input="descInput"
      :placeholder="'请将' + cnt.title + placeholder"
      :rows="4"
      :disabled="cnt.titleState == 'error'"
    ></el-input>
    <p class="error">{{ errorMsg }}</p>
    <el-button
      class="btn-border"
      :type="isSearched ? 'default' : 'primary'"
      @click="search"
      icon="el-icon-search"
      :disabled="isSearching"
      >搜索</el-button
    >
    <el-switch
      active-text="搜索完后自动开始下载"
      v-model="isAutoDownload"
      @change="changeSwitch"
    ></el-switch>
  </div>
</template>

<script>
import { message } from "@/utils/resetMessage";
import downcount from "@/components/activityCount/downcount.vue";
import { setAutoDownload, getAutoDownload } from "../../../utils/storage";
export default {
  components: {
    downcount,
  },
  props: {
    // 带有默认值的对象
    tabContent: {
      type: Object,
      default() {
        return {
          title: "",
          subTitle: "",
          label: "",
        };
      },
    },
    isSearching: {
      type: Boolean,
    },
  },
  data() {
    return {
      placeholder:
        "图片ID编号粘贴到本框提交，一个ID编号一行，多个ID号请回车另起一行输入，没有被加载说明图片不存在或无法下载…",
      errorMsg: "",
      isAutoDownload: getAutoDownload() == "1" ? true : false, //是否自动下载
      form: {
        imageId: "",
        webType: "",
      },
      isSearched: false,
      info: {
        currentTime: "",
        startDate: "",
        endDate: "",
      },
    };
  },
  computed: {
    cnt() {
      return this.tabContent;
    },
  },
  mounted() {
    this.cnt.label = "";
    this.info.currentTime = new Date();
    var timedate = this.getNowFormatDate();
    this.info.startDate = new Date(timedate + " 00:00:00");
    this.info.endDate = new Date("2023-06-19 24:00:00");
  },
  methods: {
    changeSwitch(val) {
      if (val) {
        setAutoDownload("1");
      } else {
        setAutoDownload("0");
      }
      this.isAutoDownload = val;
    },
    search() {
      if (this.cnt.label !== "" && this.cnt.label !== null) {
        if (this.cnt.label.split(/\n/).length > 500) {
          message.error({
            message: "ID行数限制500行",
            duration: 4000,
            offset: 80,
          });
          return;
        }
        this.errorMsg = "";
        var recArray = this.cnt.label.split("\n");
        //搜索过滤回车
        var recNewArray = [];
        if (
          this.cnt.webType == "alamy" ||
          this.cnt.webType == "envatoelements"
        ) {
          for (var i = 0; i < recArray.length; i++) {
            if (recArray[i].length > 3) {
              var rec = recArray[i].replace(/ /g, "");
              if (rec != null && rec != "" && typeof rec != "undefined") {
                if (recNewArray.indexOf(rec) < 0) {
                  recNewArray.push(rec);
                }
              }
            }
          }
        } else if (
          this.cnt.webType == "istockphoto" ||
          this.cnt.webType == "vistockphoto"
        ) {
          //istock的id单独处理
          for (var i = 0; i < recArray.length; i++) {
            var imageIDTemp = recArray[i];
            if (imageIDTemp.length > 3) {
              try {
                var rec = "";
                if (imageIDTemp.indexOf("-gm") > -1) {
                  //判断是否存-gm
                  rec = imageIDTemp.split("-gm")[1].split("-")[0];
                } else {
                  var pattern = /[0-9]\d{4,14}/g;
                  var matchResult = recArray[i]
                    .replace(/ /g, "")
                    .match(pattern);
                  if (matchResult.length > 0) {
                    matchResult.forEach((item) => {
                      rec += item;
                    });
                  }
                }
                if (rec != null && rec != "" && typeof rec != "undefined") {
                  if (recNewArray.indexOf(rec) < 0) {
                    recNewArray.push(rec);
                  }
                }
              } catch (e) {
                this.errorMsg = "存在ID无效";
              }
            }
          }
        } else if (this.cnt.webType == "freepik") {
          //freepik的id单独处理
          for (var i = 0; i < recArray.length; i++) {
            var imageIDTemp = recArray[i];
            if (imageIDTemp.length > 3) {
              try {
                var rec = "";
                if (imageIDTemp.indexOf(".htm") > -1) {
                  //判断是否存-gm
                  rec = imageIDTemp.split(".htm")[0].split("_")[1];
                } else {
                  var pattern = /[0-9]\d{4,14}/g;
                  var matchResult = recArray[i]
                    .replace(/ /g, "")
                    .match(pattern);
                  if (matchResult.length > 0) {
                    matchResult.forEach((item) => {
                      rec += item;
                    });
                  }
                }
                if (rec != null && rec != "" && typeof rec != "undefined") {
                  if (recNewArray.indexOf(rec) < 0) {
                    recNewArray.push(rec);
                  }
                }
              } catch (e) {
                this.errorMsg = "存在ID无效";
              }
            }
          }
        } else {
          for (var i = 0; i < recArray.length; i++) {
            if (recArray[i].length > 3) {
              if (recArray[i].startsWith("hi22")) {
                if (recNewArray.indexOf(recArray[i]) < 0) {
                  recNewArray.push(recArray[i]);
                }
              } else if (recArray[i].indexOf("hi22") > -1) {
                var rec = "hi" + recArray[i].split("?")[0].split("/hi")[1];
                recNewArray.push(rec);
              } else {
                var pattern = /[0-9]\d{4,20}/g;
                var matchResult = recArray[i].replace(/ /g, "").match(pattern);
                try {
                  if (matchResult.length > 0) {
                    var rec = "";
                    matchResult.forEach((item) => {
                      rec += item;
                    });
                    if (rec != null && rec != "" && typeof rec != "undefined") {
                      if (recNewArray.indexOf(rec) < 0) {
                        recNewArray.push(rec);
                      }
                    }
                  }
                } catch (e) {
                  this.errorMsg = "存在ID无效";
                }
              }
            }
          }
        }

        if (recNewArray.length > 0) {
          this.$emit("search", recNewArray);
          this.isSearched = true;
        } else {
          this.errorMsg = "ID不能为空";
        }
      } else {
        this.errorMsg = "ID不能为空";
      }
    },
    //费用明细
    constDetail() {
      this.$emit("constDetail");
    },
    gotoPay() {
      // this.$router.push({ path: "/pay" });
      // this.$store.commit("asideMenuId", 3);
      this.$router.push({ path: "/11huodong" });
      let routeUrl = this.$router.resolve({ path: "/11huodong" });
      window.open(routeUrl.href, "_blank");
    },
    descInput() {
      this.txtVal = this.cnt.label;
      if (this.txtVal.split(/\n/).length > 500) {
        message.error({
          message: "ID行数限制500个",
          duration: 4000,
          offset: 80,
        });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-price-entry { display: inline-flex; align-items: center; vertical-align: middle; }

.tab-content {
  background-color: white;
  padding: 30px;
  .title-wrap {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
    }
    .right{
      display: flex;
      align-items: center;
      margin-left: auto; /* 将右侧的 div 推到右边 */
    }
    .title {
      display: inline-block;
      font-size: 32px;
      color: #000;
      font-weight: bold;
    }
    .btnfr {
      margin-left: 15px;
      font-size: 14px;
    }
    .btnfr11 {
      font-weight: bold; /* 设置字体加粗 */
      margin-right: 20px;
      font-size: 16px;
      color: #ea0615;
    }
    .fr {
      margin-left: auto;
      color: #44d995;
      margin-right: 30px;
      .iconfont {
        font-size: 20px;
      }
    }
    .fr1 {
      margin-left: auto;
      color: #ea0615;
      margin-right: 30px;
      .iconfont {
        font-size: 20px;
      }
    }
    .el-button.is-circle {
      margin-right: 10px;
      padding: 0;
      width: 16px;
      height: 16px;
      line-height: 16px;
      border-radius: 50%;
    }
  }
  .btn-border.el-button {
    margin-bottom: 15px;
    padding: 15px 20px;
    width: 100%;
    font-size: 16px;
    // color: #EA4335;
    // background: #fff;
    border-color: #EA4335;
    outline: none;
    i {
      color: #EA4335;
    }
  }
  .warning {
    display: block;
    padding: 8px 16px;
    background-color: #fff6f7;
    border-radius: 4px;
    border-left: 5px solid #fe6c6f;
    margin: 20px 0;
    p {
      font-size: 14px;
      color: #5e6d82;
      line-height: 1.8em;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #EA4335;
    border-color: #EA4335;
    color: #ffffff;
  }
  .error {
    margin-bottom: 10px;
    color: #f56c6c;
  }
  .btnimg {
    display: block;
    width: 102px;
    height: 40px;
    object-fit: contain;
    cursor: pointer;
  }
}

.teach-btn {
  font-size: 14px;
  color: #EA4335;
  cursor: pointer;
}

.show-urls-btn {
  border: 1px solid #EA4335;
  color: #EA4335;
}
.btnf {
  color: #6b3d1e !important;
  font-weight: 700;
  background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
  border-color: #fff;
  font-size: 14px;
  padding: 12px 15px;
  &:hover {
    background-image: linear-gradient(90deg, #f0bb93 100%, #f0bb93 100%);
    border-color: #fff;
  }
  &:active {
    background-image: linear-gradient(90deg, #ffe9d2, #ffbf8f);
    border-color: #fff;
  }
}

.anchor {
  color: black;
}
::v-deep .el-textarea__inner {
  padding: 20px;
}

::v-deep .el-button--default {
  color: #EA4335;
}
</style>
